import http from 'http/index';
import { cas3ApiRoute } from 'http/utility';

export const mergeStudents = ({ primaryStudentId, secondaryStudentId }) => http.post(
  cas3ApiRoute('/students/merge'),
  { primaryStudentId, secondaryStudentId },
);

export default mergeStudents;
